import { connect } from 'react-redux';

import Onboarding from 'presentation/components/Onboarding';
import userEvents from 'events/user';
import checkAuth from 'actions/user/checkAuth';
import { getAuthError, getOnboarding } from 'app/modules';

export const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (name, email) => {
      //just saves the user in the store and generates an ID
      dispatch(userEvents.createOnboardingUser({ name, email }));
      //now auth again because we have an ID
      dispatch(checkAuth);
    },
  };
};

export const mapStateToProps = state => {
  let authErr;

  const configOnboardingText = getOnboarding(state);
  if (getAuthError(state)) {
    authErr = { hasEmailError: true, error: configOnboardingText.authenticationError };
  }

  return { ...configOnboardingText, ...authErr };
};

const OnboardingContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Onboarding);

export default OnboardingContainer;
